import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import Text from 'components/Text/Text';
import ChunkOfTextWithCopying from 'components/Text/ChunkOfTextWithCopying';
import style from './DownloadAppAndroidUrlField.module.scss';

const DownloadAppAndroidUrlField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<div className={style.container}>
			<Text
				translationNameSpace="form"
				translationKey="downloadAppAndroidUrlLabel"
				theme="neutralLight"
				size="xs"
			/>
			<div className={style.contentWrapper}>
				{restaurantForFullInfo?.downloadAppAndroidUrl ? (
					<>
						<Text
							translationKey={restaurantForFullInfo.downloadAppAndroidUrl || ''}
							size="s"
							withTooltip={true}
						/>
						<ChunkOfTextWithCopying
							text={restaurantForFullInfo.downloadAppAndroidUrl || ''}
							className={style.externalId}
						/>
					</>
				) : (
					'-'
				)}
			</div>
		</div>
	);
};

export default DownloadAppAndroidUrlField;
